import { useTranslation } from "react-i18next";

/**
 * Returns the translated value of a content field, falling back to the
 * original French value when no translation exists for the current language.
 *
 * Usage:
 *   const tl = useContentTranslation();
 *   tl(project, "name");
 *   tl(project, "short_description");
 */
export default function useContentTranslation() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").slice(0, 2);
  return (doc, field) => {
    if (!doc) return "";
    if (lang === "fr") return doc[field] || "";
    const tr = doc.translations || {};
    const value = tr[lang]?.[field];
    return value && String(value).trim() ? value : doc[field] || "";
  };
}
